module.exports = __webpack_public_path__ + "static/media/cht_4.f5ffaa29.jpg";